import React from 'react';
import { Link } from 'react-router-dom';

function About() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="display-4 fw-bold text-dark mb-4">
                <span className="text-warning">Chi</span> Siamo
              </h1>
              <p className="lead text-muted mb-5">
                La prima web app italiana dedicata al FantaWrestling! Un progetto nato dalla passione per il wrestling e la voglia di creare una community unica.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div className="mission-card p-4 p-lg-5 rounded-4 shadow-sm bg-white">
                <h2 className="fw-bold text-dark mb-4">
                  <i className="bi bi-bullseye text-warning me-3"></i>
                  La Nostra Idea
                </h2>
                <p className="fs-5 text-muted mb-4">
                  FantaWrestling nasce dall'idea di creare uno spazio dove la passione per il wrestling 
                  incontra la strategia e la competizione amichevole. Vogliamo offrire un'esperienza 
                  coinvolgente che unisca appassionati da tutta Italia (e non solo).
                </p>
                <div className="d-flex align-items-center">
                  <div>
                    <p className="text-muted mb-0">Realizzato da fan, per i fan</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-lg-6">
              <div className="p-4">
                <h3 className="fw-bold text-dark mb-4">Cosa troverai</h3>
                <div className="feature-list">
                  <div className="d-flex mb-4">
                    <div className="rounded-2 p-2 me-3">
                      <i className="bi bi-trophy-fill text-primary fs-4"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold text-dark mb-2">Competizione Appassionante</h5>
                      <p className="text-muted mb-0">
                        Sistemi di punteggio dettagliati che premiano conoscenza e strategia
                      </p>
                    </div>
                  </div>
                  
                  <div className="d-flex mb-4">
                    <div className="rounded-2 p-2 me-3">
                      <i className="bi bi-people-fill text-success fs-4"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold text-dark mb-2">Community Attiva</h5>
                      <p className="text-muted mb-0">
                        Unisciti a migliaia di appassionati che condividono la tua stessa passione
                      </p>
                    </div>
                  </div>
                  
                  <div className="d-flex">
                    <div className="p-2 me-3">
                      <i className="bi bi-graph-up-arrow text-danger fs-4"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold text-dark mb-2">Aggiornamenti Costanti</h5>
                      <p className="text-muted mb-0">
                        Piattaforma in continuo miglioramento con nuove funzionalità
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="text-center mb-5">
                <h2 className="fw-bold text-dark display-5 mb-3">
                  La Nascita di FantaWrestling
                </h2>
                <div className="divider mx-auto bg-warning" style={{width: '100px', height: '4px'}}></div>
              </div>
              
              <div className="story-timeline">
                <div className="timeline-item mb-5">
                  <div className="timeline-date bg-warning text-white rounded-pill px-4 py-2 d-inline-block fw-bold mb-3">
                    Aprile 2025
                  </div>
                  <div className="timeline-content bg-white p-4 rounded-4 shadow-sm">
                    <h4 className="fw-bold text-dark mb-3">L'Idea</h4>
                    <p className="text-muted mb-0">
                      Nasce l'idea di creare un fantagame dedicato al wrestling, 
                      ispirato dai fantasport tradizionali ma con meccaniche uniche adatte 
                      allo sport-entertainment.
                    </p>
                  </div>
                </div>
                
                <div className="timeline-item mb-5">
                  <div className="timeline-date bg-warning text-white rounded-pill px-4 py-2 d-inline-block fw-bold mb-3">
                    Maggio 2025
                  </div>
                  <div className="timeline-content bg-white p-4 rounded-4 shadow-sm">
                    <h4 className="fw-bold text-dark mb-3">Lo Sviluppo</h4>
                    <p className="text-muted mb-0">
                      Sviluppo della piattaforma con focus su usabilità e esperienza mobile. 
                      Creazione del sistema di punteggio dettagliato che considera match, 
                      storyline e performance speciali.
                    </p>
                  </div>
                </div>
                
                <div className="timeline-item">
                  <div className="timeline-date bg-warning text-white rounded-pill px-4 py-2 d-inline-block fw-bold mb-3">
                    Oggi
                  </div>
                  <div className="timeline-content bg-white p-4 rounded-4 shadow-sm">
                    <h4 className="fw-bold text-dark mb-3">La Community</h4>
                    <p className="text-muted mb-0">
                      FantaWrestling è oggi una community attiva che conta centinaia di appassionati, 
                      con leghe competitive e un sistema in continua evoluzione basato sul 
                      feedback degli utenti.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Legal Disclaimer */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="alert alert-warning border-warning bg-warning bg-opacity-10 rounded-4">
            <div className="d-flex">
              <div className="me-3">
                <i className="bi bi-exclamation-triangle-fill fs-3 text-warning"></i>
              </div>
              <div>
                <h5 className="fw-bold text-dark mb-2">Avviso Legale</h5>
                <p className="text-dark mb-0">
                  FantaWrestling è un progetto indipendente realizzato da appassionati per appassionati. 
                  Non siamo affiliati con nessuna federazione di wrestling. 
                  Tutti i nomi di wrestler e federazioni sono utilizzati a solo scopo informativo e di gioco.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-5">
        <div className="container">
          <div className="text-center">
            <h2 className="fw-bold text-dark display-5 mb-4">
              Pronto a Unirti a Noi?
            </h2>
            <p className="lead text-muted mb-5">
              Inizia la tua avventura nel mondo del FantaWrestling
            </p>
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <Link to="/auth" className="btn btn-brand-primary-light btn-lg p-2">
                <i className="bi bi-play-fill me-2"></i>
                Registrati Ora
              </Link>
              <Link to="/rules" className="btn btn-outline-dark btn-lg p-2">
                <i className="bi bi-book me-2"></i>
                Leggi le regole
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
{/* Values Section 
<section className="py-5 bg-dark text-light">
  <div className="container">
    <div className="text-center mb-5">
      <h2 className="fw-bold display-5 mb-3">
        I Nostri <span className="text-warning">Valori</span>
      </h2>
      <p className="lead opacity-75">
        I principi che guidano ogni nostra decisione
      </p>
    </div>
    
    <div className="row g-4">
      <div className="col-md-4">
        <div className="value-card text-center p-4 h-100">
          <div className="value-icon bg-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-4" 
               style={{width: '80px', height: '80px'}}>
            <i className="bi bi-shield-check fs-2 text-dark"></i>
          </div>
          <h4 className="fw-bold mb-3">Trasparenza</h4>
          <p className="opacity-75">
            Regole chiare, sistemi di punteggio pubblici e comunicazione aperta 
            con la community.
          </p>
        </div>
      </div>
      
      <div className="col-md-4">
        <div className="value-card text-center p-4 h-100">
          <div className="value-icon bg-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-4" 
               style={{width: '80px', height: '80px'}}>
            <i className="bi bi-arrow-repeat fs-2 text-dark"></i>
          </div>
          <h4 className="fw-bold mb-3">Innovazione</h4>
          <p className="opacity-75">
            Costante miglioramento della piattaforma basato sul feedback degli utenti 
            e sulle novità del wrestling.
          </p>
        </div>
      </div>
      
      <div className="col-md-4">
        <div className="value-card text-center p-4 h-100">
          <div className="value-icon bg-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-4" 
               style={{width: '80px', height: '80px'}}>
            <i className="bi bi-people fs-2 text-dark"></i>
          </div>
          <h4 className="fw-bold mb-3">Community</h4>
          <p className="opacity-75">
            Al centro c'è la community: uno spazio inclusivo dove condividere la passione 
            per il wrestling.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
            */}

{/* Team Section 
<section className="py-5">
  <div className="container">
    <div className="text-center mb-5">
      <h2 className="fw-bold text-dark display-5 mb-3">
        Dietro le Quinte
      </h2>
      <p className="lead text-muted">
        FantaWrestling è realizzato da un team di appassionati
      </p>
    </div>
    
    <div className="row justify-content-center">
      <div className="col-md-8 col-lg-6">
        <div className="team-card bg-white p-5 rounded-4 shadow-sm text-center">
          <div className="team-avatar bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4" 
               style={{width: '120px', height: '120px'}}>
            <i className="bi bi-person-fill-gear fs-1 text-warning"></i>
            </div>
          <h3 className="fw-bold text-dark mb-3">Team FantaWrestling</h3>
          <p className="text-muted mb-4">
            Siamo sviluppatori, designer e soprattutto fan del wrestling. 
            Lavoriamo per creare l'esperienza che avremmo sempre voluto avere 
            come appassionati.
          </p>
          <div className="d-flex justify-content-center gap-3">
            <a href="https://www.instagram.com/fanta.wrestling/" 
               target="_blank" 
               rel="noopener noreferrer"
               className="btn btn-outline-dark btn-sm">
              <i className="bi bi-instagram me-2"></i>
              Instagram
            </a>
            <a href="https://t.me/fantawrestlingchat" 
               target="_blank" 
               rel="noopener noreferrer"
               className="btn btn-outline-dark btn-sm">
              <i className="bi bi-telegram me-2"></i>
              Telegram
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
*/}